<template>
  <b-button-group>
    <template v-if="!isCompletedOrCanceledStatus">
      <McButton
        class="__button-group"
        icon="icon-outline_checkmark"
        :text="nextStatus.actionBtnText"
        :disabled="isLoading"
        @click="handleClickItem(nextStatus.key)"
      />

      <div class="mc-border"></div>
    </template>

    <b-dropdown
      class="mc-buttons-dropdown"
      variant="primary"
      :toggle-tag="isCompletedOrCanceledStatus ? 'div': undefined"
      :toggle-class="isCompletedOrCanceledStatus ? 'p-0 bg-transparent' : undefined"
      :disabled="isLoading"
    >
      <template #button-content>
        <McButton
          v-if="isCompletedOrCanceledStatus"
          variant="secondary"
          icon="icon-outline_chevron-down"
          icon-position="right"
          :text="$t('salesOrder.text.manageSalesOrder')"
        />
        <i v-else class="mc-icon icon-outline_chevron-down" style="font-size: 18px" />
      </template>

      <b-dropdown-item
        v-for="status in computedStatuses"
        :key="status.key"
        :disabled="isLoading"
        @click="handleClickItem(status.key)"
      >
        <template v-if="status.key === 'DELETE'">
          <hr class="m-0 mb-2" />
          <div class="red-text">
            <i class="icon-outline_trash" />
            <span>{{ status.label }}</span>
          </div>
        </template>

        <div v-else class="d-flex gap-2">
          <span>{{ $t('salesOrder.text.transitionTo') }}</span>
          <McBadge type="button" size="sm" :text="status.label" :variant="status.variant" />
        </div>
      </b-dropdown-item>
    </b-dropdown>
  </b-button-group>
</template>

<script>
import McButton from '@/components/McButton'
import McBadge from '@/components/McBadge'

export default {
  components: {
    McButton,
    McBadge,
  },
  props: {
    currentStatus: {
      type: String,
      default: '',
    },
    statuses: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  computed: {
    nextStatus() {
      return this.statuses[0]
    },
    isCompletedOrCanceledStatus() {
      return ['COMPLETED', 'CANCELED'].includes(this.currentStatus)
    },
    computedStatuses() {
      if (this.isCompletedOrCanceledStatus) {
        return this.statuses
      }

      return this.statuses.toSpliced(0, 1)
    },
  },
  methods: {
    handleClickItem(status) {
      this.$emit('click', status)
    },
  },
}
</script>

<style lang="scss" scoped>
:deep(.__button-group) {
  .mc-button {
    border-radius: 4px 0 0 4px;
    height: 100%;
  }
}

:deep(.mc-buttons-dropdown) {
  .icon-provider {
    width: 20px;
  }

  .mc-icon:before {
    color: $white;
  }
}

:deep(.mc-border) {
  width: 2px;
  background: $white;
}

:deep(.red-text) {
  color: $red;
  display: flex;
  gap: 8px;
  align-items: center;

  i:before {
    color: $red;
    font-size: 16px;
  }
}
</style>
